module.exports = __webpack_public_path__ + "static/media/AdobeStock_310541670.3cd24618.jpg";